























































import Vue, {VueConstructor} from 'vue'
import {DateTime} from 'luxon'

export default (Vue as VueConstructor<Vue & {
  $refs: {
    calendar: { months: DateTime[] },
  }
}>).extend({
  name: 'thirdStep',
  props: {
    scope: {} as () => {mailingId: string},
    mailingId: String
  },
  data () {
    return {
      sendAt: false,
      finishAt: false,
      dateStart: 0,
      dateEnd: 0,
      tmpDateStart: '',
      tmpDateEnd: '',
      pickerOptions: {
        firstDayOfWeek: 1,
        format: 'HH:mm'
      }
    }
  },
  computed: {
  },
  methods: {
    prev () {
      this.$emit('prev')
    },
    submit () {
      if (!this.sendAt) {
        this.setDateStart(DateTime.local().plus({ seconds: 10 }).toMillis())
      }

      if (!this.finishAt) {
        this.setDateEnd(DateTime.fromMillis(this.dateStart).plus({ years: 1 }).toMillis())
      }

      if (!this.dateStart) {
        // @ts-ignore
        this.$message({
          // @ts-ignore
          message: this.$t('labels.specify_date_of_sending'), type: 'warning'});
      } else if (!this.dateEnd) {
        // @ts-ignore
        this.$message({
          // @ts-ignore
          message: this.$t('labels.specify_date_of_result'), type: 'warning'});
      } else {
        this.$emit('submit')
      }
    },
    next () {
      this.$emit('next')
    },
    onInput () {
      this.$emit('input', {send_at: this.dateStart, finish_at: this.dateEnd})
    },
    setDateStart (value: number) {
      if (value === null) {
        return;
      }

      let now = DateTime.local().toMillis()
      if (value > now) {
        this.dateStart = value

        if (!this.finishAt) {
          this.setDateEnd(DateTime.fromMillis(value).plus({ years: 1 }).toMillis())
        }

        this.onInput()
      } else {
        this.tmpDateStart = ''
        this.dateStart = 0
        // @ts-ignore
        this.$message({
          // @ts-ignore
          message: this.$t('labels.not_allow_past_date'), type: 'warning'});
      }
    },
    setDateEnd (value: number) {
      if (value > this.dateStart) {
        this.dateEnd = value
        this.onInput()
      } else {
        this.tmpDateEnd = ''
        this.dateEnd = 0
        // @ts-ignore
        this.$message({
          // @ts-ignore
          message: this.$t('labels.result_date_must_be_after_send'),
          type: 'warning'
        });
      }
    }
  },
  mounted () {
  },
  watch: {
    sendAt (value) {
      if (value) {
        this.tmpDateStart = ''
        this.dateStart = 0
      } else {
        this.setDateStart(DateTime.local().toMillis())
      }
    },
    finishAt (value) {
      if (value) {
        this.tmpDateEnd = ''
        this.dateEnd = 0
      } else {
        this.setDateEnd(DateTime.local().plus({ years: 1 }).toMillis())
      }
    }
  }
})
